<form [formGroup]="form">
  <div class="dynamics-container">
    <div class="vehicles-grid">
      <div class="vehicle-section">
        <h4 class="vehicle-header" [ngClass]="'vehicle-a-header'">
          <mat-icon class="vehicle-icon">directions_car</mat-icon>
          {{ 'dynamics.vehicleA' | translate }}: {{ plate || '' }}
          <span class="count">({{ getSelectedCount('A') }} / {{ vehicleOptions.length }})</span>
        </h4>
        <div class="options-list">
          @for (option of getVisibleOptions('A'); track option.id) {
            <mat-checkbox
              [checked]="isOptionSelected('A', option.id!.toString())"
              (change)="onVehicleChange('A', option.id!.toString(), $event)"
              color="primary">
              {{ option.description | translate }}
            </mat-checkbox>
          }
          @if (!showAllStates['A'] && vehicleOptions.length > limitShowElement) {
            <button mat-button color="primary" (click)="showAllStates['A'] = true" class="show-all-btn">
              {{ 'dynamics.showAll' | translate }} ({{ vehicleOptions.length - limitShowElement }} {{ 'dynamics.remaining' | translate }})
            </button>
          }
          @if (showAllStates['A']) {
            <button mat-button color="accent" (click)="showAllStates['A'] = false" class="show-all-btn">
              {{ 'dynamics.reduceOptions' | translate }}
            </button>
          }
        </div>
      </div>

      @for (vehicle of involvedVehicles; track vehicle.plate; let i = $index) {
        <div class="vehicle-section">
          <h4 class="vehicle-header" [ngClass]="getVehicleHeaderClass(i + 1)">
            <mat-icon class="vehicle-icon">local_shipping</mat-icon>
            {{ 'dynamics.vehicle' | translate }} {{ vehicleLetters[i + 1] }}: {{ vehicle.plate }}
            <span class="count">({{ getSelectedCount(vehicleLetters[i + 1]) }} / {{ vehicleOptions.length }})</span>
          </h4>
          <div class="options-list">
            @for (option of getVisibleOptions(vehicleLetters[i + 1]); track option.id) {
              <mat-checkbox
                [checked]="isOptionSelected(vehicleLetters[i + 1], option.id!.toString())"
                (change)="onVehicleChange(vehicleLetters[i + 1], option.id!.toString(), $event)"
                color="primary">
                {{ option.description | translate }}
              </mat-checkbox>
            }
          @if (!showAllStates[vehicleLetters[i + 1]] && vehicleOptions.length > limitShowElement) {
            <button mat-button color="primary" (click)="showAllStates[vehicleLetters[i + 1]] = true" class="show-all-btn">
              {{ 'dynamics.showAll' | translate }} ({{ vehicleOptions.length - limitShowElement }} {{ 'dynamics.remaining' | translate }})
            </button>
          }
          @if (showAllStates[vehicleLetters[i + 1]]) {
            <button mat-button color="accent" (click)="showAllStates[vehicleLetters[i + 1]] = false" class="show-all-btn">
              {{ 'dynamics.reduceOptions' | translate }}
            </button>
          }
          </div>
        </div>
      }
    </div>
  </div>
</form>
